const translation = {
  tags: {
    productivity: '生產力',
    business: '商',
    finance: '金融',
    weather: '天氣',
    news: '新聞',
    design: '設計',
    utilities: '公用事業',
    education: '教育',
    travel: '旅行',
    other: '其他',
    social: '社會的',
    medical: '醫療',
    agent: '代理',
    videos: '視頻',
    entertainment: '娛樂',
    search: '搜索',
    image: '圖像',
  },
  searchTags: '搜索標籤',
  allTags: '所有標籤',
}

export default translation
